<template>
    <v-container>
        <v-row>
            <v-col sm="6" v-for="(app, index) in filteredApps" :key="index">
                <v-card height="100%">
                    <v-container fill-height>
                        <v-row class="fill-height">
                            <v-col md="3">
                                <v-img
                                    max-height="100"
                                    :src="getLogoSrc(app.id)"
                                    contain
                                ></v-img>
                            </v-col>
                            <v-col md="9" class="d-flex flex-column">
                                <v-card-title>{{ app.name }}</v-card-title>
                                <v-card-text
                                    class="text-body-1 flex-grow-1"
                                    style="white-space: pre-wrap;"
                                    >{{
                                        $t(`${app.id}.description`)
                                    }}</v-card-text
                                >
                                <v-divider></v-divider>
                                <v-card-actions
                                    class="flex-wrap justify-space-around"
                                >
                                    <v-btn
                                        v-if="app.downloadUrl"
                                        class="mb-2 mb-lg-0"
                                        color="primary"
                                        outlined
                                        :href="app.downloadUrl"
                                        target="_blank"
                                        rel="noopener,noreferrer"
                                        ><v-icon class="mr-2"
                                            >mdi-microsoft-windows</v-icon
                                        >{{ $t("Windows") }}</v-btn
                                    >

                                    <v-btn
                                        v-if="app.appGallery"
                                        class="mb-2 mb-lg-0"
                                        color="primary"
                                        outlined
                                        :href="app.appGallery"
                                        target="_blank"
                                        rel="noopener,noreferrer"
                                        ><v-icon class="mr-2"
                                            >mdi-download</v-icon
                                        >{{ $t("XEROX App Gallery") }}</v-btn
                                    >
                                    <v-btn
                                        v-if="app.doc"
                                        color="primary"
                                        outlined
                                        :href="
                                            app.doc.replace(
                                                '{lang}',
                                                $i18n.locale
                                            )
                                        "
                                        target="_blank"
                                        rel="noopener,noreferrer"
                                        ><v-icon class="mr-2"
                                            >mdi-book-open-outline</v-icon
                                        >{{ $t("Documentation") }}</v-btn
                                    >
                                </v-card-actions>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import apps from "@/assets/apps/apps.json";

export default {
    name: "Applications",
    computed: {
        filteredApps() {
            return apps
                .filter(x => x.locales.includes(this.$i18n.locale))
                .sort((a, b) => a.order - b.order);
        }
    },
    methods: {
        getLogoSrc(name) {
            return require(`@/assets/apps/${name}.png`);
        }
    }
};
</script>
